import { CONTACT } from "@/data/content";
import { Reveal, SectionHead } from "@/components/Reveal";

export default function Contact() {
  return (
    <section id="contact" data-testid="contact-section" className="section-pad bg-paper">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead eyebrow={CONTACT.eyebrow} title={CONTACT.title} />
        <Reveal delay={0.15}>
          <p className="mt-8 max-w-xl text-body-sm text-ink/65 md:mt-12 md:text-body">{CONTACT.sub}</p>
        </Reveal>
        <div className="mt-10 hairline-t border-line">
          <div className="grid grid-cols-1 sm:grid-cols-2 sm:gap-x-12">
            {CONTACT.rows.map((r, idx) => (
              <Reveal key={r.label} delay={0.2 + idx * 0.05}>
                <div className="hairline-b border-line py-5" data-testid={r.testid}>
                  <p className="text-label uppercase text-ink/45">{r.label}</p>
                  {r.href ? (
                    <a
                      href={r.href}
                      data-testid="contact-email-link"
                      className="mt-1 block text-lg font-medium text-accent underline decoration-accent/30 underline-offset-4 transition-colors hover:decoration-accent"
                    >
                      {r.value}
                    </a>
                  ) : (
                    <p className="mt-1 text-lg font-medium">{r.value}</p>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
